import { toast } from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

// Deliberately does NOT invalidate queries on success - the caller decides when. The
// merged-away patient 404s as soon as it is refetched, and usePatientData navigates away
// on a 404, so a blind invalidation here can take someone off the screen that is still
// reporting what the merge did.
//
// Both callers handle that themselves and differently: MergePatientModal, on the patient
// card, invalidates once the person has read the summary and closes it; MergePatientsPage,
// in the admin area, freezes both records into its result first and invalidates then.
export const useMergePatient = () => {
  const handleNetworkError = useHandleNetworkError("Error merging patient");

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ existingPatientId, newPatientId }) => {
      const axiosInstance = createAxiosInstance();

      const response = await axiosInstance.post(`${tenantVal}/patient/merge`, {
        existingPatientId,
        newPatientId,
      });
      return response.data;
    },
    onSuccess: () => {
      toast.success("Patient merged successfully");
    },
    onError: handleNetworkError,
  });
};
